import React from 'react';

// @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
export const TableStateContext = React.createContext();

export const TableStateProvider = ({ children, ...props }: any) => (
  <TableStateContext.Provider value={props}>
    {children}
  </TableStateContext.Provider>
);
